import { AgsLoopWinsState } from "ags/state-machine/states/ags-loop-wins-state";
import { Components } from "appworks/components/components";
import { Layers } from "appworks/graphics/layers/layers";
import { ThemeLoopWinsComponent } from "components/theme-loop-wins-component";

export class ThemeLoopWinsState extends AgsLoopWinsState {

    public onEnter(): void {

        let celebrationContract = Components.get(ThemeLoopWinsComponent).start();
        celebrationContract.then(() => this.complete());
    }

    public onSkip() {

        super.onSkip();
        Layers.get("CelebrationContent").defaultScene().execute();
    }
}
